import React from "react";
import { AppBtn } from "../../../ui/buttons";
import Modal, { ModalBody, ModalFooter } from "../../../ui/modal-full";
import { StoreInterface } from "@/assets/interfaces";

interface Props {
  storeName: string;
  show: boolean;
  toggle: (state: boolean) => void;
  store: StoreInterface;
  getImageModal: () => void;
}

const AboutStoreModal: React.FC<Props> = ({ storeName, show, toggle, store, getImageModal }) => {

  return (
    <Modal {...{ show, toggle }} fullOnlyOnMobile title="About Our Brand" bgClose={false}>
      <ModalBody className="">
        <div className="space-y-5">
          <div className="w-full flex flex-col">
            <p className="text-dark text-1sm whitespace-pre-line leading-[1.5]">{store?.about_us?.content}</p>
          </div>
          <div className="w-full flex flex-row flex-wrap gap-3.75 mt-3.75">
            {store?.about_us?.images?.map((image) => (
              <figure className="h-30 w-30 sm:h-36 sm:w-36 rounded-15 overflow-hidden cursor-pointer" onClick={getImageModal}>
                <img src={image} alt="about us" className="w-full h-full object-cover" />
              </figure>
            ))}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AboutStoreModal;
